(function () {
  if (window.bfFootiePdpLoaded) return;
  window.bfFootiePdpLoaded = true;

  var catalogPromise;
  var patternTooltip;
  var rootSelector = '[data-bf-footie-pdp]';

  function root() {
    return document.querySelector(rootSelector);
  }

  function fitProductTitle() {
    var section = document.querySelector('[data-bf-footie-title]');
    var title = section && section.querySelector('.product__info-container .product__title h1');
    if (!title || !title.parentElement.clientWidth) return;
    var max = window.matchMedia('(max-width: 749px)').matches ? 42 : 64;
    var low = 14;
    var high = max;
    var available = title.clientWidth;
    for (var i = 0; i < 10; i++) {
      var size = (low + high) / 2;
      title.style.fontSize = size + 'px';
      if (title.scrollWidth <= available) low = size;
      else high = size;
    }
    title.style.fontSize = Math.floor(low * 10) / 10 + 'px';
    if (!title.dataset.bfTitleObserved && window.ResizeObserver) {
      title.dataset.bfTitleObserved = 'true';
      new ResizeObserver(fitProductTitle).observe(title.parentElement);
    }
    if (document.fonts && document.fonts.ready && !title.dataset.bfFontFitPending) {
      title.dataset.bfFontFitPending = 'true';
      document.fonts.ready.then(function () {
        if (title.isConnected) fitProductTitle();
      });
    }
  }

  function currentHandle() {
    return location.pathname.split('/').filter(Boolean).pop();
  }

  function patternName(title) {
    return title.replace(/ Zippered Footie$/i, '');
  }

  function label(template, token, value) {
    return template.replace(token, value);
  }

  function showPatternTooltip(button, name) {
    if (!patternTooltip) {
      patternTooltip = document.createElement('div');
      patternTooltip.className = 'bf-footie-pattern-tooltip';
      patternTooltip.setAttribute('role', 'tooltip');
      document.body.append(patternTooltip);
    }
    var bounds = button.getBoundingClientRect();
    patternTooltip.textContent = name;
    patternTooltip.style.left = bounds.left + bounds.width / 2 + 'px';
    patternTooltip.style.top = bounds.top - 8 + 'px';
    patternTooltip.hidden = false;
  }

  function hidePatternTooltip() {
    if (patternTooltip) patternTooltip.hidden = true;
  }

  function catalog() {
    if (!catalogPromise) {
      var url = new URL('/collections/footie-pajamas', location.origin);
      url.searchParams.set('view', 'bf-footie-catalog');
      url.searchParams.set('sort_by', 'best-selling');
      var main = root();
      if (main && main.dataset.bfThemeId) url.searchParams.set('preview_theme_id', main.dataset.bfThemeId);
      catalogPromise = fetch(url.toString(), {
        credentials: 'same-origin'
      }).then(function (response) {
        if (!response.ok) throw new Error('Footie catalog unavailable');
        return response.json();
      }).then(function (data) {
        return (data.products || []).filter(function (product) {
          return /zippered footie/i.test(product.title) && product.available;
        });
      }).catch(function () {
        return fetch('/collections/footie-pajamas/products.json?limit=250', {
          credentials: 'same-origin'
        }).then(function (response) {
          if (!response.ok) throw new Error('Footie catalog unavailable');
          return response.json();
        }).then(function (data) {
          return (data.products || []).filter(function (product) {
            return /zippered footie/i.test(product.title) &&
              product.variants && product.variants.some(function (variant) { return variant.available; });
          });
        });
      }).catch(function (error) {
        catalogPromise = null;
        throw error;
      });
    }
    return catalogPromise;
  }

  function centeredProducts(products) {
    var selectedIndex = products.findIndex(function (product) {
      return product.handle === selectedHandle();
    });
    if (selectedIndex < 0) return products;
    var start = (selectedIndex - Math.floor(products.length / 2) + products.length) % products.length;
    return products.slice(start).concat(products.slice(0, start));
  }

  function fallbackImage(product) {
    var first = product.images && product.images[0];
    return first && (first.src || first) || product.image && product.image.src || '';
  }

  function selectedHandle() {
    var handle = currentHandle();
    return handle === 'turtle-zippered-footie-copy'
      ? 'turtle-bamboo-zipper-baby-footie-pajama' : handle;
  }

  function addPatternImageInset(main) {
    var media = main.querySelector('.product__media-wrapper media-gallery .product__media-item .product-media-container');
    if (!media || media.querySelector('.bf-footie-pattern-inset')) return;
    var inset = document.createElement('span');
    var image = document.createElement('img');
    var svgNamespace = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNamespace, 'svg');
    var path = document.createElementNS(svgNamespace, 'path');
    var text = document.createElementNS(svgNamespace, 'text');
    var textPath = document.createElementNS(svgNamespace, 'textPath');
    var title = main.querySelector('.product__title h1');
    var name = patternName(title ? title.textContent.trim() : '');
    var pathId = 'bf-footie-pattern-ring-' + (main.dataset.section || 'main');
    inset.className = 'bf-footie-pattern-inset';
    inset.setAttribute('aria-hidden', 'true');
    image.alt = '';
    image.decoding = 'async';
    image.src = 'https://cdn.starapps.studio/v2/apps/vsk/bamboo-little-shop/groups/129945/' +
      encodeURIComponent(selectedHandle()) + '.media';
    image.addEventListener('error', function () { inset.hidden = true; }, { once: true });
    svg.setAttribute('viewBox', '0 0 100 100');
    svg.setAttribute('focusable', 'false');
    path.id = pathId;
    path.setAttribute('d', 'M 4 50 A 46 46 0 1 1 96 50 A 46 46 0 1 1 4 50');
    textPath.setAttribute('href', '#' + pathId);
    textPath.textContent = label(main.dataset.bfInsetPatternLabel || '[pattern] Pattern', '[pattern]', name);
    text.append(textPath);
    svg.append(path, text);
    inset.append(image, svg);
    media.append(inset);
  }

  function layoutPatterns(grid) {
    var items = Array.from(grid.querySelectorAll('.bf-footie-switcher__item'));
    var rows = window.matchMedia('(max-width: 749px)').matches ? 2 : 3;
    var selectedIndex = items.findIndex(function (item) {
      return item.getAttribute('aria-current') === 'true';
    });
    var selectedRow = selectedIndex >= 0 ? selectedIndex % rows + 1 : 0;
    var middleIndex = selectedIndex >= 0 ? Math.floor(selectedIndex / rows) * rows + 1 : -1;
    items.forEach(function (item, index) {
      var row = index % rows + 1;
      if (selectedRow !== 2) {
        if (index === selectedIndex) row = 2;
        else if (index === middleIndex) row = selectedRow;
      }
      item.style.gridColumn = Math.floor(index / rows) + 1;
      item.style.gridRow = row;
    });
  }

  function centerSelected(grid) {
    var current = grid.querySelector('[aria-current="true"]');
    if (!current || !grid.clientWidth) return;
    var gridBounds = grid.getBoundingClientRect();
    var currentBounds = current.getBoundingClientRect();
    var maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
    var position = grid.scrollLeft + currentBounds.left - gridBounds.left -
      (grid.clientWidth - currentBounds.width) / 2;
    grid._bfSelectedCenterScroll = Math.max(0, Math.min(maxScroll, position));
    grid.scrollLeft = grid._bfSelectedCenterScroll;
    updatePatternScrollbar(grid);
  }

  function thumbProgress(grid, maxScroll) {
    if (!maxScroll) return 0;
    var center = grid._bfSelectedCenterScroll;
    var scroll = Math.max(0, Math.min(maxScroll, grid.scrollLeft));
    if (typeof center !== 'number' || center <= 0 || center >= maxScroll) return scroll / maxScroll;
    return scroll <= center ? scroll / center * .5 : .5 + (scroll - center) / (maxScroll - center) * .5;
  }

  function scrollForThumbProgress(grid, progress, maxScroll) {
    var center = grid._bfSelectedCenterScroll;
    if (typeof center !== 'number' || center <= 0 || center >= maxScroll) return progress * maxScroll;
    return progress <= .5 ? progress * 2 * center : center + (progress - .5) * 2 * (maxScroll - center);
  }

  function updatePatternScrollbar(grid) {
    var scrollbar = grid.parentElement.querySelector('.bf-footie-switcher__scrollbar');
    if (!scrollbar) return;
    var thumb = scrollbar.firstElementChild;
    var maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
    var visiblePercent = grid.scrollWidth ? grid.clientWidth / grid.scrollWidth * 100 : 100;
    var trackWidth = scrollbar.clientWidth;
    var thumbWidth = trackWidth * Math.min(100, Math.max(18, visiblePercent)) / 100;
    var progress = thumbProgress(grid, maxScroll);
    thumb.style.width = thumbWidth + 'px';
    thumb.style.transform = 'translate3d(' +
      (progress * (trackWidth - thumbWidth)) + 'px, 0, 0)';
    scrollbar.setAttribute('aria-valuenow', Math.round(progress * 100));
    scrollbar.setAttribute('aria-disabled', maxScroll ? 'false' : 'true');
  }

  function decorateOptions(main) {
    main.querySelectorAll('variant-radios .product-form__input').forEach(function (field) {
      if (field.querySelector('input[name="Color"]')) field.classList.add('bf-footie-color');
      if (!field.querySelector('input[name="Size"]')) return;
      field.classList.add('bf-footie-size');
      var legend = field.querySelector('legend');
      if (!legend) return;
      var title = legend.querySelector('.bf-footie-size-label');
      if (!title) {
        title = document.createElement('span');
        title.className = 'bf-footie-size-label';
        legend.prepend(title);
        Array.from(legend.childNodes).forEach(function (node) {
          if (node.nodeType === 3) node.remove();
        });
      }
      title.textContent = main.dataset.bfSizeLabel;
      var selected = legend.querySelector('.bf-footie-size-selected');
      if (!selected) {
        selected = document.createElement('span');
        selected.className = 'bf-footie-size-selected';
        title.after(selected);
      }
      var checkedSize = field.querySelector('input[name="Size"]:checked');
      selected.textContent = checkedSize ? checkedSize.value : '';
      var chart = main.querySelector('.product__info-container > .link.btn-popup');
      if (chart && chart.parentElement !== legend) legend.append(chart);
    });
    main.querySelectorAll('.swatches.swatches-type-products').forEach(function (swatches) {
      swatches.hidden = true;
    });
  }

  function positionReviewTeaser(main) {
    var badge = main.querySelector('.jdgm-prev-badge');
    var teaser = main.querySelector('.bf-footie-review-teaser');
    if (!badge || !teaser) return;
    var title = main.querySelector('.product__info-container .product__title');
    if (title) title.classList.remove('bf-footie-title-with-review');
    if (teaser.parentElement !== badge) badge.append(teaser);
  }

  function positionMobileReviews(main) {
    var widget = main.querySelector('.jdgm-widget.jdgm-preview-badge');
    var info = main.querySelector('.product__info-container');
    var price = info && info.querySelector('[id^="price-"]');
    var block = widget && widget.closest('.shopify-block');
    if (!block || !price || !info) return;
    var anchor = info.querySelector('.bf-footie-review-anchor');
    if (!anchor) {
      if (!info.contains(block)) return;
      anchor = document.createElement('span');
      anchor.className = 'bf-footie-review-anchor';
      anchor.hidden = true;
      block.before(anchor);
    }
    var mount = main.querySelector('.bf-footie-mobile-reviews');
    if (window.matchMedia('(max-width: 749px)').matches) {
      if (!mount) {
        mount = document.createElement('div');
        mount.className = 'bf-footie-mobile-reviews';
        price.after(mount);
      }
      if (mount.previousElementSibling !== price) price.after(mount);
      if (block.parentElement !== mount) mount.append(block);
    } else {
      if (block.parentElement !== info) anchor.before(block);
      if (mount) mount.remove();
    }
  }

  function syncReviewCount(main) {
    var badge = main.querySelector('.jdgm-prev-badge');
    if (!badge) return;
    var text = badge.querySelector('.jdgm-prev-badge__text');
    var count = Number(badge.dataset.numberOfReviews);
    if (!text || !Number.isInteger(count) || count < 0) return;
    var display = count > 10 ? '(' + count + ')' : '';
    if (text.textContent !== display) text.textContent = display;
  }

  function watchReviewCount(main) {
    var widget = main.querySelector('.jdgm-widget.jdgm-preview-badge');
    if (!widget || widget.dataset.bfReviewCountWatched) return;
    widget.dataset.bfReviewCountWatched = 'true';
    new MutationObserver(function () {
      syncReviewCount(main);
    }).observe(widget, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-number-of-reviews']
    });
  }

  function teaserAuthor(name, fallback) {
    var normalizedName = (name || '').trim();
    if (!normalizedName || /^bamboo\s+little\s+customer$/i.test(normalizedName)) return fallback;
    var parts = normalizedName.split(/\s+/);
    if (parts.length < 2) return parts[0] || '';
    var lastInitial = Array.from(parts.pop())[0].toLocaleUpperCase();
    return parts.join(' ') + ' ' + lastInitial + '.';
  }

  function fitReviewTeaser(main) {
    var teaser = main.querySelector('.bf-footie-review-teaser');
    var quote = teaser && teaser.querySelector('.bf-footie-review-teaser__quote');
    if (!quote || !teaser.clientWidth || !quote.dataset.bfFullQuote) return;
    var badge = teaser.closest('.jdgm-prev-badge');
    if (badge && badge.closest('.bf-footie-mobile-reviews')) {
      var stars = badge.querySelector('.jdgm-prev-badge__stars');
      var count = badge.querySelector('.jdgm-prev-badge__text:not(:empty)');
      var starsWidth = stars ? Math.ceil(stars.getBoundingClientRect().width) : 0;
      var countWidth = count ? Math.ceil(count.getBoundingClientRect().width) : 0;
      badge.style.setProperty('--bf-review-stars-width', starsWidth + 1 + 'px');
      badge.style.setProperty('--bf-review-leading-width', starsWidth + countWidth + (count ? 4 : 1) + 'px');
    }
    teaser.style.removeProperty('text-indent');
    var full = quote.dataset.bfFullQuote;
    var style = getComputedStyle(teaser);
    var lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.4;
    var maxHeight = lineHeight * 2 + 1;
    function fits(length) {
      quote.textContent = length === full.length ? '“' + full + '”' : '“' + full.slice(0, length).trimEnd() + '…”';
      return teaser.getBoundingClientRect().height <= maxHeight && teaser.scrollWidth <= teaser.clientWidth + 1;
    }
    if (!fits(full.length)) {
      var low = 0;
      var high = full.length;
      while (low < high) {
        var middle = Math.ceil((low + high) / 2);
        if (fits(middle)) low = middle;
        else high = middle - 1;
      }
      var boundary = full.lastIndexOf(' ', low - 1);
      if (boundary >= 0 && boundary >= low - 16) low = boundary;
      fits(low);
    }
    if (document.fonts && document.fonts.ready && !teaser.dataset.bfFontFitPending) {
      teaser.dataset.bfFontFitPending = 'true';
      document.fonts.ready.then(function () {
        if (teaser.isConnected) fitReviewTeaser(main);
      });
    }
  }

  function reviewTeaser(main) {
    var badge = main.querySelector('.jdgm-prev-badge');
    syncReviewCount(main);
    watchReviewCount(main);
    var widget = document.querySelector('#judgeme_product_reviews');
    if (main.querySelector('.bf-footie-review-teaser')) {
      positionReviewTeaser(main);
      return;
    }
    if (!badge || !widget) return;
    var count = Number(badge.dataset.numberOfReviews);
    if (!count || count >= 20) return;
    var owner = badge.closest('[data-id]');
    if (owner && widget.dataset.id && owner.dataset.id !== widget.dataset.id) return;
    var review = widget.querySelector('.jdgm-rev');
    if (!review) return;
    var author = review.querySelector('.jdgm-rev__author');
    var body = review.querySelector('.jdgm-rev__body');
    var title = review.querySelector('.jdgm-rev__title');
    var timestamp = review.querySelector('.jdgm-rev__timestamp[datetime]');
    var quote = body && body.textContent.trim() || title && title.textContent.trim();
    if (!quote) return;
    var button = document.createElement('button');
    var quoteText = document.createElement('span');
    var byline = document.createElement('span');
    button.type = 'button';
    button.className = 'bf-footie-review-teaser';
    quoteText.className = 'bf-footie-review-teaser__quote';
    quoteText.dataset.bfFullQuote = quote;
    quoteText.textContent = '“' + quote + '”';
    byline.className = 'bf-footie-review-teaser__byline';
    var authorName = document.createElement('span');
    authorName.className = 'bf-footie-review-teaser__author';
    authorName.textContent = '— ' + teaserAuthor(author && author.textContent, main.dataset.bfVerifiedReviewLabel);
    byline.append(authorName);
    button.append(quoteText, document.createTextNode(' '), byline);
    if (timestamp) {
      var reviewDate = new Date(timestamp.getAttribute('datetime'));
      if (!Number.isNaN(reviewDate.getTime())) {
        var date = document.createElement('time');
        date.dateTime = timestamp.getAttribute('datetime');
        var month = new Intl.DateTimeFormat('en-US', {
          month: 'short', timeZone: 'UTC'
        }).format(reviewDate).replace(/\.$/, '');
        authorName.textContent += ',';
        date.textContent = month + ". '" + String(reviewDate.getUTCFullYear()).slice(-2);
        byline.append(document.createTextNode(' '), date);
      }
    }
    button.setAttribute('aria-label', '“' + quote + '” ' + byline.textContent);
    button.addEventListener('click', function () {
      var id = review.dataset.reviewId;
      var target = id && document.querySelector('#judgeme_product_reviews .jdgm-rev[data-review-id="' + id + '"]') || review;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
    badge.append(button);
    positionReviewTeaser(main);
  }

  function finish(main) {
    decorateOptions(main);
    reviewTeaser(main);
    positionMobileReviews(main);
    fitReviewTeaser(main);
    [500, 1500, 3500].forEach(function (delay) {
      setTimeout(function () {
        if (main.isConnected) {
          decorateOptions(main);
          reviewTeaser(main);
          positionMobileReviews(main);
          fitReviewTeaser(main);
        }
      }, delay);
    });
  }

  function refreshReviewWidget() {
    var source = Array.from(document.scripts).find(function (script) {
      return /\/review_widget\.js(?:\?|$)/.test(script.src);
    });
    if (!source) return;
    var script = document.createElement('script');
    var url = new URL(source.src);
    url.searchParams.set('bf-footie-refresh', Date.now().toString());
    script.type = 'module';
    script.src = url.toString();
    document.head.append(script);
  }

  function render() {
    fitProductTitle();
    var main = root();
    if (main) addPatternImageInset(main);
    if (!main || main.querySelector('.bf-footie-switcher') || main.dataset.bfFootiePending) return;
    var picker = main.querySelector('.product__info-container variant-radios, .product__info-container variant-selects');
    if (!picker) return;
    main.dataset.bfFootiePending = 'true';
    finish(main);
    catalog().then(function (products) {
      if (!main.isConnected || !products.length) return;
      var wrap = document.createElement('div');
      var heading = document.createElement('h3');
      var shell = document.createElement('div');
      var viewport = document.createElement('div');
      var grid = document.createElement('div');
      var scrollbar = document.createElement('div');
      var thumb = document.createElement('div');
      var status = document.createElement('p');
      wrap.className = 'bf-footie-switcher';
      heading.className = 'bf-footie-switcher__label';
      shell.className = 'bf-footie-switcher__shell';
      viewport.className = 'bf-footie-switcher__viewport';
      grid.className = 'bf-footie-switcher__grid';
      grid.id = 'bf-footie-pattern-grid-' + main.dataset.section;
      scrollbar.className = 'bf-footie-switcher__scrollbar';
      thumb.className = 'bf-footie-switcher__scrollbar-thumb';
      scrollbar.setAttribute('role', 'scrollbar');
      scrollbar.setAttribute('aria-label', main.dataset.bfScrollPatterns);
      scrollbar.setAttribute('aria-controls', grid.id);
      scrollbar.setAttribute('aria-orientation', 'horizontal');
      scrollbar.setAttribute('aria-valuemin', '0');
      scrollbar.setAttribute('aria-valuemax', '100');
      scrollbar.tabIndex = 0;
      status.className = 'bf-footie-switcher__status';
      status.setAttribute('role', 'status');
      grid.setAttribute('role', 'group');
      var current = products.find(function (product) { return product.handle === selectedHandle(); });
      heading.textContent = label(main.dataset.bfPatternLabel, '[pattern]', current ? patternName(current.title) : '');

      centeredProducts(products).forEach(function (product) {
        var button = document.createElement('button');
        var image = document.createElement('img');
        var name = patternName(product.title);
        button.type = 'button';
        button.className = 'bf-footie-switcher__item';
        button.dataset.handle = product.handle;
        button.title = name;
        button.setAttribute('aria-label', label(main.dataset.bfViewPattern, '[title]', product.title));
        if (product.handle === selectedHandle()) button.setAttribute('aria-current', 'true');
        button.addEventListener('mouseenter', function () { showPatternTooltip(button, name); });
        button.addEventListener('focus', function () { showPatternTooltip(button, name); });
        button.addEventListener('mouseleave', hidePatternTooltip);
        button.addEventListener('blur', hidePatternTooltip);
        image.alt = '';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.src = 'https://cdn.starapps.studio/v2/apps/vsk/bamboo-little-shop/groups/129945/' +
          encodeURIComponent(product.handle) + '.media';
        image.addEventListener('error', function () {
          var fallback = fallbackImage(product);
          if (fallback && image.src !== fallback) image.src = fallback;
        }, { once: true });
        button.append(image);
        button.addEventListener('click', function () {
          hidePatternTooltip();
          swap(product, wrap, status);
        });
        grid.append(button);
      });
      layoutPatterns(grid);

      var previous = document.createElement('button');
      var next = document.createElement('button');
      previous.type = next.type = 'button';
      previous.className = 'bf-footie-switcher__arrow';
      next.className = 'bf-footie-switcher__arrow';
      previous.textContent = '‹';
      next.textContent = '›';
      previous.setAttribute('aria-label', main.dataset.bfScrollLeft);
      next.setAttribute('aria-label', main.dataset.bfScrollRight);
      previous.addEventListener('click', function () {
        grid.scrollBy({ left: -Math.max(220, grid.clientWidth * 0.7), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        grid.scrollBy({ left: Math.max(220, grid.clientWidth * 0.7), behavior: 'smooth' });
      });
      function updateArrows() {
        previous.disabled = grid.scrollLeft < 4;
        next.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 4;
      }
      grid.addEventListener('scroll', updateArrows, { passive: true });
      grid.addEventListener('scroll', function () { updatePatternScrollbar(grid); }, { passive: true });
      grid.addEventListener('scroll', hidePatternTooltip, { passive: true });
      var pointerOffset = 0;
      var dragFrame = 0;
      var dragClientX = 0;
      function scrollFromPointer(clientX) {
        var bounds = scrollbar.getBoundingClientRect();
        var travel = Math.max(0, bounds.width - thumb.offsetWidth);
        var left = Math.max(0, Math.min(travel, clientX - bounds.left - pointerOffset));
        var maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
        grid.scrollLeft = travel ? scrollForThumbProgress(grid, left / travel, maxScroll) : 0;
      }
      function schedulePointerScroll(clientX) {
        dragClientX = clientX;
        if (dragFrame) return;
        dragFrame = requestAnimationFrame(function () {
          dragFrame = 0;
          scrollFromPointer(dragClientX);
        });
      }
      scrollbar.addEventListener('pointerdown', function (event) {
        if (event.button !== 0) return;
        event.preventDefault();
        pointerOffset = event.target === thumb
          ? event.clientX - thumb.getBoundingClientRect().left : thumb.offsetWidth / 2;
        scrollbar.setPointerCapture(event.pointerId);
        schedulePointerScroll(event.clientX);
      });
      scrollbar.addEventListener('pointermove', function (event) {
        if (scrollbar.hasPointerCapture(event.pointerId)) schedulePointerScroll(event.clientX);
      });
      scrollbar.addEventListener('pointerup', function (event) {
        if (!scrollbar.hasPointerCapture(event.pointerId)) return;
        if (dragFrame) cancelAnimationFrame(dragFrame);
        dragFrame = 0;
        scrollFromPointer(event.clientX);
        scrollbar.releasePointerCapture(event.pointerId);
      });
      scrollbar.addEventListener('pointercancel', function () {
        if (dragFrame) cancelAnimationFrame(dragFrame);
        dragFrame = 0;
      });
      scrollbar.addEventListener('keydown', function (event) {
        var distance = Math.max(80, grid.clientWidth * .7);
        if (event.key === 'ArrowLeft') grid.scrollLeft -= distance;
        else if (event.key === 'ArrowRight') grid.scrollLeft += distance;
        else if (event.key === 'Home') grid.scrollLeft = 0;
        else if (event.key === 'End') grid.scrollLeft = grid.scrollWidth;
        else return;
        event.preventDefault();
      });
      scrollbar.append(thumb);
      viewport.append(grid, scrollbar);
      shell.append(previous, viewport, next);
      wrap.append(heading, shell, status);
      picker.before(wrap);
      centerSelected(grid);
      requestAnimationFrame(function () {
        updateArrows();
        updatePatternScrollbar(grid);
      });
    }).catch(function () {
      main.dataset.bfFootiePending = '';
    });
  }

  function swap(product, wrap, status) {
    var main = root();
    if (!main || wrap.dataset.loading === 'true' || product.handle === currentHandle()) return;
    var mainSection = main.closest('.shopify-section');
    var reviewSections = Array.from(document.querySelectorAll('.jdgm-review-widget')).map(function (widget) {
      return widget.closest('.shopify-section');
    }).filter(function (section, index, all) {
      return section && section !== mainSection && all.indexOf(section) === index;
    });
    var sections = [mainSection].concat(reviewSections);
    var ids = sections.map(function (section) { return section.id.replace(/^shopify-section-/, ''); });
    var url = new URL('/products/' + encodeURIComponent(product.handle), location.origin);
    url.searchParams.set('sections', ids.join(','));
    url.searchParams.set('preview_theme_id', main.dataset.bfThemeId);
    wrap.dataset.loading = 'true';
    status.textContent = label(main.dataset.bfLoading, '[title]', product.title);

    fetch(url.toString(), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Product unavailable');
        return response.json();
      }).then(function (parts) {
        var replacements = sections.map(function (section, index) {
          var html = parts[ids[index]];
          if (!html) throw new Error('Product section unavailable');
          var documentPart = new DOMParser().parseFromString(html, 'text/html');
          var fresh = documentPart.getElementById(section.id);
          if (!fresh) throw new Error('Product section unavailable');
          return { old: section, fresh: fresh };
        });
        replacements.forEach(function (pair) {
          pair.fresh.querySelectorAll('script').forEach(function (script) {
            var match = script.textContent.match(/jdgm\.data\.reviewWidget\[(\d+)\]\s*=\s*(\{[\s\S]*\})\s*;?\s*$/);
            if (!match) return;
            try {
              window.jdgm = window.jdgm || {};
              window.jdgm.data = window.jdgm.data || {};
              window.jdgm.data.reviewWidget = window.jdgm.data.reviewWidget || {};
              window.jdgm.data.reviewWidget[match[1]] = JSON.parse(match[2]);
            } catch (error) { /* Widget markup remains available. */ }
          });
        });
        replacements.forEach(function (pair) {
          pair.old.replaceWith(document.importNode(pair.fresh, true));
        });
        var pageUrl = new URL('/products/' + encodeURIComponent(product.handle), location.origin);
        pageUrl.searchParams.set('preview_theme_id', main.dataset.bfThemeId);
        history.pushState({ bfFootie: true }, '', pageUrl.toString());
        document.title = product.title + ' | Bamboo Little';
        ids.forEach(function (id) {
          var section = document.getElementById('shopify-section-' + id);
          if (section) section.dispatchEvent(new CustomEvent('shopify:section:load', {
            bubbles: true, detail: { sectionId: id }
          }));
        });
        refreshReviewWidget();
        render();
      }).catch(function () {
        wrap.dataset.loading = 'false';
        status.textContent = main.dataset.bfError;
      });
  }

  document.addEventListener('click', function (event) {
    var main = root();
    if (!main) return;
    var chart = event.target.closest('.bf-footie-size .btn-popup');
    if (chart && main.contains(chart)) {
      event.preventDefault();
      var popup = main.querySelector(chart.dataset.target);
      if (popup) {
        popup.classList.add('is-open');
        document.body.classList.add('overflow-hidden');
      }
      return;
    }
    var close = event.target.closest('.size-popup__close');
    if (close && main.contains(close)) {
      var open = main.querySelector('.size-popup.is-open');
      if (open) {
        open.classList.remove('is-open');
        document.body.classList.remove('overflow-hidden');
      }
    }
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('input[name="Size"]')) return;
    var main = root();
    if (!main || !main.contains(event.target)) return;
    var field = event.target.closest('.bf-footie-size');
    var selected = field && field.querySelector('.bf-footie-size-selected');
    if (selected) selected.textContent = event.target.checked ? event.target.value : '';
  });

  window.addEventListener('popstate', function () { location.reload(); });
  window.addEventListener('resize', function () {
    fitProductTitle();
    var main = root();
    var grid = main && main.querySelector('.bf-footie-switcher__grid');
    if (main) {
      positionReviewTeaser(main);
      positionMobileReviews(main);
      fitReviewTeaser(main);
    }
    if (grid) {
      layoutPatterns(grid);
      centerSelected(grid);
      requestAnimationFrame(function () { updatePatternScrollbar(grid); });
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();
})();
